const STOCK_ALERT_FORM_SELECTOR = '[data-stock-alert-form]';
const LOADING_CLASS = 'is-loading';

document.addEventListener('click', async (event) => {
  const submitButton = event.target instanceof Element
    ? event.target.closest('[data-stock-alert-submit]')
    : null;

  if (!(submitButton instanceof HTMLButtonElement)) {
    return;
  }

  const target = submitButton.closest(STOCK_ALERT_FORM_SELECTOR);

  if (!(target instanceof HTMLElement) || target.classList.contains(LOADING_CLASS)) {
    return;
  }

  const feedback = target.querySelector('[data-stock-alert-message]');
  const languageInput = target.querySelector('input[name="language"]');
  const countryInput = target.querySelector('input[name="country"]');
  const action = target.dataset.stockAlertAction;

  if (!action || !(feedback instanceof HTMLElement)) {
    return;
  }

  const fields = getSubmittableFields(target);

  if (!validateFields(fields)) {
    return;
  }

  if (languageInput instanceof HTMLInputElement) {
    languageInput.value = window.Shopify?.locale || target.dataset.language || 'es';
  }

  if (countryInput instanceof HTMLInputElement) {
    countryInput.value = window.Shopify?.country || target.dataset.country || 'ES';
  }

  setFeedback(feedback, '');
  setSubmitState(submitButton, true);
  target.classList.add(LOADING_CLASS);

  try {
    const response = await fetch(action, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      body: buildFormData(fields),
    });

    const payload = await response.json().catch(() => null);

    if (!response.ok || payload?.ok === false) {
      throw new Error(payload?.error || 'Stock alert request failed.');
    }

    resetFields(fields);
    setFeedback(feedback, target.dataset.successMessage || '', 'success');
  } catch (error) {
    console.error('Error creating stock alert request:', error);
    setFeedback(feedback, target.dataset.errorMessage || '', 'error');
  } finally {
    setSubmitState(submitButton, false);
    target.classList.remove(LOADING_CLASS);
  }
});

function setFeedback(feedback, message, type = '') {
  const messageText = feedback.querySelector('[data-stock-alert-message-text]');
  if (messageText) {
    messageText.textContent = message;
  } else {
    feedback.textContent = message;
  }
  feedback.hidden = message.length === 0;
  feedback.dataset.state = type;

  const fields = feedback.closest(STOCK_ALERT_FORM_SELECTOR)?.querySelector('[data-stock-alert-fields]');
  const succeeded = type === 'success' && message.length > 0;
  if (fields) {
    fields.hidden = succeeded;
  }
  if (succeeded) {
    feedback.focus();
  }
}

function getSubmittableFields(container) {
  return Array.from(container.querySelectorAll('input, select, textarea')).filter((field) => {
    if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement)) {
      return false;
    }

    return !field.disabled && field.name;
  });
}

function validateFields(fields) {
  for (const field of fields) {
    if (!field.checkValidity()) {
      field.reportValidity();
      return false;
    }
  }

  return true;
}

function buildFormData(fields) {
  const formData = new FormData();

  for (const field of fields) {
    if ((field instanceof HTMLInputElement && (field.type === 'checkbox' || field.type === 'radio')) && !field.checked) {
      continue;
    }

    if (field instanceof HTMLInputElement && field.type === 'file') {
      for (const file of Array.from(field.files || [])) {
        formData.append(field.name, file);
      }
      continue;
    }

    formData.append(field.name, field.value);
  }

  return formData;
}

function resetFields(fields) {
  for (const field of fields) {
    if (field instanceof HTMLInputElement) {
      if (field.type === 'hidden') {
        continue;
      }

      if (field.type === 'checkbox' || field.type === 'radio') {
        field.checked = field.defaultChecked;
        continue;
      }

      if (field.type === 'file') {
        field.value = '';
        continue;
      }

      field.value = field.defaultValue;
      continue;
    }

    if (field instanceof HTMLTextAreaElement) {
      field.value = field.defaultValue;
      continue;
    }

    if (field instanceof HTMLSelectElement) {
      const defaultOption = Array.from(field.options).find((option) => option.defaultSelected);

      if (defaultOption) {
        field.value = defaultOption.value;
      } else {
        field.selectedIndex = 0;
      }
    }
  }
}

function setSubmitState(button, loading) {
  button.disabled = loading;
  button.setAttribute('aria-busy', loading ? 'true' : 'false');

  const idleLabel = button.dataset.idleLabel || '';
  const loadingLabel = button.dataset.loadingLabel || idleLabel;

  if (idleLabel) {
    button.textContent = loading ? loadingLabel : idleLabel;
  }
}
